/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState, useEffect } from 'react';
import { object, string } from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import CustomCarousel from '../TrendingProducts/Partials/CustomCarousel';
import { setRecentlyViewedProducts, getRecentlyViewedProducts } from '../../../../../state/ducks/Member/ducks/Auth/helper/helper';
import ProductTitle from '../../GraphqlProductPage/Partials/ProductTitle';
import ProductDivider from '../../GraphqlProductPage/Partials/ProductDivider';

const styles = (theme) => ({
    root: {
        '& a': {
            textDecoration: 'none',
        },
        '& .slick-slide.slick-cloned': {
            display: 'none',
        },
        '& .productWrapper .title-row': {
            marginTop: theme.spacing(3),
            '&>div': {
                display: 'flex',
                alignItems: 'flex-start',
                '&>span': {
                    width: '50%',
                    '&:nth-child(2)': {
                        textAlign: 'right',
                    },
                    '& p span': {
                        fontSize: '1rem',
                    },
                },
            },
        },
        '& .slick-slide': {
            paddingLeft: '0px !important',
            paddingRight: '0px !important',
        },
    },
});

const ProductRecentlyViewed = ({ classes, product, presentationFamily }) => {
    const [data, setData] = useState([]);
    const carousel_settings = {
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        centerMode: false,
        centerPadding: '0px',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    arrows: false,
                    slidesToShow: 2.2,
                    slidesToScroll: 1,
                    dots: false,
                    centerPadding: '15px',
                },
            },
        ],
    };
    useEffect(() => {
        let recentProduct = getRecentlyViewedProducts();
        if (product && Object.keys(product)?.length > 0) {
            setRecentlyViewedProducts(product);
            recentProduct = recentProduct.filter((item) => item.partNumber !== product.partNumber);
        }
        setData(recentProduct);
    }, []);
    return (
        <>
            {data && data.length ? (
                <div className={classes.root}>
                    <ProductTitle title="RECENTLY VIEWED" />
                    <CustomCarousel withPrice="1" data={data || []} presentationFamily={presentationFamily}  carousel_settings={carousel_settings} />
                    <ProductDivider />
                </div>
            ) : null}
        </>
    );
};

ProductRecentlyViewed.propTypes = {
    classes: object.isRequired,
    product: object.isRequired,
    presentationFamily: string.isRequired,
};

export default withStyles(styles)(ProductRecentlyViewed);
